<!--  -->
<template>
     <div class='wrapper box_v'>
        <div class="title">企业类别</div>
        <div class='box_f1 companyType' id="echart_cheif_qiyetype"></div>
    </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
//import echarts from 'echarts'
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";
export default {
    //import引入的组件需要注入到对象中才能使用
    components: {},
    data() {
    //这里存放数据
        return {
			colorArr : [
					am4core.color("rgba(137, 118, 255, 1)"),
					am4core.color("rgba(75, 124, 255,1)"),
					am4core.color("rgba(75, 236, 255, 1)"),
					am4core.color("rgba(0, 255, 150, 1)"),
					am4core.color("rgba(253, 138, 61, 1)"),
					am4core.color("rgba(249,248,113,1)")
				],
			fillColorArr : [
					am4core.color("rgba(137, 118, 255, 0.7)"),
					am4core.color("rgba(75, 124, 255,0.7)"),
					am4core.color("rgba(75, 236, 255, 0.7)"),
					am4core.color("rgba(0, 255, 150, 0.7)"),
					am4core.color("rgba(253, 138, 61, 0.7)"),
					am4core.color("rgba(249,248,113,0.7)")
				]
        };
    },
    //监听属性 类似于data概念
    computed: {},
    //监控data中的数据变化
    watch: {},
    //方法集合
    methods: {
		getData(){
			this.$get(this.urlobj.companyType).then(res=>{
				let chartData = res.rows.map((item,index)=>{
					return {
						...item,
						color:this.colorArr[index],
						fillColor:this.fillColorArr[index],
					}
				})
				this.initChart(chartData)
			})
			
		},	
        
        initChart(chartData){
		   am4core.ready(function() {

				// Themes begin
				am4core.useTheme(am4themes_animated);
				// Themes end

				let chart = am4core.create("echart_cheif_qiyetype", am4charts.PieChart3D);
				chart.hiddenState.properties.opacity = 0; // this creates initial fade-in
				chart.depth = 20
				chart.angle = 60
				//chart.legend = new am4charts.Legend();

				chart.data = chartData
				console.log(chartData)
				

				let series = chart.series.push(new am4charts.PieSeries3D());
				series.dataFields.value = "count";
				series.dataFields.category = "typeName";
				series.slices.template.propertyFields.fill = "fillColor";
				//series.slices.template.fillOpacity = 0.7;

// 				var fillModifier = new am4core.RadialGradientModifier();
// fillModifier.opacities = [0, 0, 0, 0, 1];
// fillModifier.offsets = [0, 0.2, 0.5, 0.8, 1];

// pieSeries.slices.template.fillModifier = fillModifier;

				//标题
				series.labels.template.propertyFields.fill = "color";
				//series.labels.template.html="{typeName}</br>{count}"

				//支出去的线
				series.ticks.template.propertyFields.stroke = "color";
				series.ticks.template.strokeOpacity =1;
				console.log(series.labels.template)

				console.log('series')
				console.log(series)
			  
				// let fillModifier = new am4core.LinearGradientModifier();
				// fillModifier.opacities = [1, 0,0,0, 1];
				// fillModifier.offsets = [0, 0.2, 0.5, 0.8, 1];
				// series.slices.template.fillModifier = fillModifier;

				}); 
	   }
		   
    },
    //生命周期 - 创建完成（可以访问当前this实例）
    created() {
		this.getData()
    },
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {
    },
    beforeCreate() {}, //生命周期 - 创建之前
    beforeMount() {}, //生命周期 - 挂载之前
    beforeUpdate() {}, //生命周期 - 更新之前
    updated() {}, //生命周期 - 更新之后
    beforeDestroy() {}, //生命周期 - 销毁之前
    destroyed() {}, //生命周期 - 销毁完成
    activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
    }
</script>
<style lang='less' scoped>
//@import url(); 引入公共css类
.wrapper{
    height:100%;
    width:100%;
    background-image: url('../../../../assets/images/monitorpy/bottom.png');
	background-size: 100% 100%;
	position:relative
}
.title{
    font-size: 18px;
    font-weight: bold;
    color: #FFFFFF;
    margin-left: 40px;
    margin-top: 20px
}

.companyType{
	position:absolute;
	top:50px;
	bottom:10px;
	left:10px;
	width:490px;
	//height:200px;

}
</style>